<template>
    <v-container class="article">
        <v-row>
            <v-col cols="12" class="text-center secondary-font px-0">
                <v-card class="clickable" color="#232323" dark>
                    <v-img
                        :src="getImage()"
                        class="white--text align-end"
                        min-height="350px"
                        max-height="550px"
                        contain
                    >
                        <v-card-title class="text-h6" style="background: #232323; text-align: justify; word-break: break-word;" v-text="article.title" />
                    </v-img>
                </v-card>
            </v-col>
        </v-row>
        <v-row class="white " justify="center" align="center">
            <v-col cols="12" style="font-size: 18px; background-color: #232323; color: white;" align="center" class="py-10">
                <span style="text-align: justify;" v-html="article.content" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import momentTimezone from 'moment-timezone'
    import articleService from '@/services/article'
    export default {
        data() {
            return {
                article: null
            }
        },
        watch: {
            '$route.params.id': {
                handler() {
                    this.getArticle()
                }
            }
        },
        created() {
            this.getArticle()
        },
        methods: {
            getImage() {
                return `${'https://storage.googleapis.com'}/${this.article.image}`
            },
            getDate() {
                return momentTimezone(this.article.date).tz('Europe/Athens').locale('el-GR').format('d/M/y, hh:mm').toString()
            },
            getArticle() {
                articleService.getArticle(this.$route.params.id).then(resp => {
                    this.article = resp.data
                })
            }
        }
    }
</script>

<style>
/* Make images and embedded media from TinyMCE responsive and fit the article container */
.article img,
.article video,
.article iframe,
.article embed,
.article object {
    max-width: 100% !important;
    height: auto !important;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

/* Ensure figures and captions don't overflow */
.article figure {
    max-width: 100% !important;
    overflow: hidden;
}

/* If TinyMCE injects width attributes, override them */
.article [width] {
    max-width: 100% !important;
    width: auto !important;
}

/* Optional: make tables responsive inside article content */
.article table {
    width: 100% !important;
    table-layout: auto !important;
}
</style>
